import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import PrivacyForm from "../component/PrivacyForm";
import SystemDataService from "../../../services/KangarooServices/SystemDataService";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import { Triangle } from "react-loader-spinner";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const TermsCondition = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await SystemDataService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const navigate = useNavigate();

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const getFullHTML = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    // Make all <a> tags open in new tab
    div.querySelectorAll("a").forEach((a) => {
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML; // returns the full HTML content
  };

  // const handleDeleteClick = async (key) => {
  //     await SystemDataService.delete(key);
  //     window.location.reload();
  //   };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await SystemDataService.delete(selectedDeleteItem.id);
        await fetchData();
        toast.success("Privacy Policy deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete Privacy Policy"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  //   const getShortHTML = (html, limit = 700) => {
  //   const div = document.createElement("div");
  //   div.innerHTML = html;
  //   const text = div.innerText;

  //   if (text.length <= limit) return html;

  //   return text.slice(0, limit) + "...";
  // };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Terms & Condition" pageTitle="Settings" />
          {/* <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => navigate("/system-setup/create")}
            >
              + Create
            </button>
          </div> */}
          {isLoading ? (
            <div className="my-3 d-flex justify-content-center align-items-center">
              <Triangle height="100" width="100" color="#556ee6" />
            </div>
          ) : (
            <>
              <Row className="d-flex justify-content-center">
                {data?.items?.[1] && (
                  <Col lg={8}>
                    <Card>
                      <div className="bg-info-subtle position-relative">
                        <CardBody className="p-5">
                          <div className="text-center mb-2">
                            <h3>{data.items[1].heading}</h3>
                            <p className="mb-0 text-muted">
                              Last update:{" "}
                              {formatDateTime(data.items[0].createdAt)}
                            </p>
                          </div>

                          <div className="d-flex justify-content-end gap-2">
                            <button
                              className="btn btn-sm btn-info"
                              onClick={() =>
                                navigate(
                                  `/terms-condition/detail/${data.items[1].id}`
                                )
                              }
                            >
                              <i className="ri-eye-fill" title="View"></i>
                            </button>

                            <button
                              className="btn btn-sm btn-success"
                              onClick={() =>
                                navigate(
                                  `/terms-condition/update/${data.items[1].id}`
                                )
                              }
                            >
                              <i className="bx bxs-edit" title="Edit"></i>
                            </button>
                          </div>
                        </CardBody>
                      </div>

                      <CardBody className="p-4">
                        <div
                          className="text-muted"
                          dangerouslySetInnerHTML={{
                            __html: getFullHTML(data.items[1].content),
                          }}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
            </>
          )}
        </Container>
      </div>
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </React.Fragment>
  );
};

export default TermsCondition;
